import { call, put, takeEvery } from "redux-saga/effects";
import { types } from "../action-types";
import { getGigRoleApi } from "../../API/API";

function* getroleSaga(action) {
    try {
        const response = yield call(() => getGigRoleApi());
        yield put({ type: types.GET_GIG_ROLES_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: types.GET_GIG_ROLES_FAILURE, error });
        console.warn(error);
    }
}

export function* watchGetRoles() {
    yield takeEvery(types.GET_GIG_ROLES_REQUESTED, getroleSaga);
}
